import parseCryptoToken from "../../../../../utils/parseCryptoToken";
import {NETWORKS_DETAILED_NAMES} from "../../../../../constants/networks";
import upperFirst from "mn-utils/upperFirst";
import toLower from "mn-utils/toLower";

export default (trxData) => {
  const NETWORK_SYNONYMS = {
    matic: 'Polygon'
  };

  const currencyPrefix = !!trxData.sc_amount ? 'sc' : 'fiat'

  const getKeyViaPrefix = (key) => [currencyPrefix, key].join('_');
  const getCurrencyData = (key) => trxData[getKeyViaPrefix(key)];

  const currencyAmount = getCurrencyData('amount');
  const currencyCode = getCurrencyData('code');
  const feeCode = getCurrencyData('fee_code');

  const parsedCryptoToken = parseCryptoToken(trxData.currency_code);
  const BPaySymbol = 'EUR (Binance Pay)';
  const cryptoCurrencyCode = parsedCryptoToken[1] === 'EUR' ? BPaySymbol : parsedCryptoToken[1];

  const networkRaw = NETWORK_SYNONYMS[trxData.network] || trxData.network || parsedCryptoToken[0];
  const network = NETWORKS_DETAILED_NAMES[networkRaw] || upperFirst(networkRaw || '');

  return {
    paymentId: trxData.payment_id || '',
    orderId: trxData.order_id || '',
    auctionId: trxData.auction_id || '',
    refundId: trxData.refund_id || '',

    transactionKind: trxData.transaction_kind || '',
    retailerName: trxData.retailer_name,

    desc: trxData.order_description,
    hash: trxData.hash,
    email: trxData.email,
    date: trxData.date_time,

    currencyPrefix,
    currencyAmount,
    currencyCode,

    cryptoCurrencyAmount: trxData.currency_amount,
    parsedCryptoToken,
    BPaySymbol,
    cryptoCurrencyCode,

    network,

    refundableAmount: Number(trxData.refundable_amount || 0),
    refundsList: trxData.refunds || [],

    retailerFeeAmount: trxData.retailer_fee_amount,
    customerFeeAmount: trxData.customer_fee_amount,
    feeCode,

    status: toLower(trxData.transaction_status || ''),
  }
}
